import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminNavbar from '../Navbar/Navbar';
import SuperAdminSidebar from '../../screens/SuperAdmin/SuperAdminSidebar';

const SuperAdminLayout = () => {

  return (
    <div>
      <header>
        <AdminNavbar />
      </header>
      <main>
        <SuperAdminSidebar />
        <Outlet mi />
      </main>
      <footer>
        {/* Add your admin footer here */}
      </footer>
    </div>
  );
};

export default SuperAdminLayout;
